import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MediaService } from './../../../services/media.service';
import { SafeHtml, DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { AppConfig } from './../../../config/app-config';
import { FileSection, FileType, FileData } from './../../../models/fileData';

@Component({
  selector: 'app-media-article',
  templateUrl: './media-article.component.html',
  styleUrls: ['./media-article.component.css']
})
export class MediaArticleComponent implements OnInit {

  mediaId: number;

  OtherMediaArticles$: any[] = [];

  MediaArticle$ = {
    "title": "",
    "articleDate": "",
    "categoryId": 0,
    "description": "",
    "copy": null
  };

  Images$: any[] = [];

  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  fbUrl = "https://www.facebook.com/sharer.php?" + window.location.href;
  liUrl = "http://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href;
  twUrl = "https://twitter.com/share?url=" + window.location.href + "&text=";

  
  /*
   * 
   * @param route
   * @param mediaService
   * @param sanitizer
   * @param datePipe
   * @param appConfig
   */
  constructor(
    private route: ActivatedRoute,
    private mediaService: MediaService,
    protected sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private appConfig: AppConfig) {
    this.route.queryParams.subscribe((params) => {
      this.mediaId = params['mediaId'];
    });
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loadMediaArticle(this.mediaId);
  }

  loadMediaArticle(mediaId) {
    this.mediaService.getMediaArticle(mediaId).subscribe((response) => {

      var data = response as {};

      this.mediaService.getMediaCategoriesList().subscribe((catResponse) => {
        this.MediaArticle$.title = response.title;
        const myDate = response.articleDate as Date;
        this.MediaArticle$.articleDate = this.datePipe.transform(myDate, 'dd MMM yyyy');//myDate.getDay() + ' ' + this.monthNames[myDate.getMonth()] + ' ' + myDate.getFullYear();
        try {
          //this.MediaArticle$.categoryId = response.categoryId;
          this.MediaArticle$.categoryId = catResponse.find(x => x.id === response.categoryId).title;
        } catch (e) {

        }
        
        this.MediaArticle$.description = response.description;
        this.MediaArticle$.copy = this.sanitizer.bypassSecurityTrustHtml(response.copy);
        this.getImages(response.id);

        this.getOtherMediaReleases(response.id);
        $('#loading').hide();
        
        //this.twUrl += escape(response.title);
      });

    }, (error) => {
      console.log(error);
    })
  }

  getImages(linkedId) {

    this.Images$ = [];

    let baseUrl = this.appConfig.baseUrl;

    this.mediaService.getImages(linkedId).subscribe((response) => {
      let imageArray: any[] = [];

      response.forEach(function (val, idx, arr) {
        val.fileLocation = baseUrl + '/Uploads/' + FileSection[val.fileSection] + '/' + FileType[val.fileType] + '/' + val.linkedId + '/' + val.physicalFileName;
        imageArray.push(val.fileLocation);
      });

      this.Images$ = imageArray;

    }, (error) => {
      console.log(error);
    });
  }

  getOtherMediaReleases(id) {
    this.mediaService.getOtherMediaArticles(id).subscribe((response) => {
      this.OtherMediaArticles$ = response as any[];
    }, (error) => {
        console.log(error);
    });
  }

}
